export default __webpack_public_path__ + "static/media/ContentSuiteWhiteIcon.9bc172e9.svg";